import get from '@invitato/helpers/dist/getLocale';

export default {
  title: get('Tanda Kasih', 'Wedding Gift'),
  desc: get(
    `Bagi yang ingin memberikan tanda kasih, dapat mengirimkan melalui fitur di bawah ini:`,
    `For beloved ones who may want to show your sincere love by sending a gift, please kindly tap the button below:`,
  ),
  sendGift: get('Kirim Hadiah', 'Send Gift'),
  modalCopy: get('Salin Nomor Rekening', 'Copy Account Number'),
  modalCopyAddress: get('Salin Alamat', 'Copy Address'),
  success: get('Sukses!', 'Success!'),
  successCopyRekening: get(
    'Nomor rekening berhasil disalin.',
    'Account number copied successfully.',
  ),
  successCopyAddress: get('Alamat berhasil disalin.', 'Address copied successfully.'),
  failedCopied: get(
    'Terjadi kesalahan. Mohon muat ulang browser Anda atau coba lagi nanti.',
    'Something wrong happened. Please try again later or refresh your browser!',
  ),
};
